import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PortalServiceFactory } from '../../services/portal-service.factory';
import { LocalStorageService } from '../../services/local-storage.service';
import { PortalBaseComponent } from '../portal-base.component';
import { PortalScope } from '../../login/login.component';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'e-sign-via-token-confirmation',
    templateUrl: './e-sign-via-token-confirmation.component.html',
    styleUrls: ['./e-sign-via-token-confirmation.component.scss'],
    standalone: false
})
export class ESignViaTokenConfirmationComponent
  extends PortalBaseComponent
  implements OnInit {

  isAgent: boolean = false;

  protected taskNumber: number;
  protected allTasksCount: number;

  protected messageKey = '';
  protected messageTitleKey = '';
  protected messageParams: Record<string, number> = {};

  private _orderId: number;

  constructor(
    private readonly portalServiceFactory: PortalServiceFactory,
    private readonly _spinner: NgxSpinnerService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _localStorage: LocalStorageService,
    private readonly _utilsService: UtilsService
  ) {
    super(portalServiceFactory);
  }

  ngOnInit(): void {
    const portalScope = this._localStorage.getItem('portalScope') as PortalScope;
    if (portalScope && portalScope == PortalScope.Agent) {
      this.isAgent = true;
    }

    const eSignToken = this._activatedRoute.snapshot.paramMap.get('token');
    this.taskNumber = Number(this._activatedRoute.snapshot.paramMap.get('taskNumber')) + 1;
    this.allTasksCount = Number(this._activatedRoute.snapshot.paramMap.get('allTasksCount'));
    this._orderId = Number(this._activatedRoute.snapshot.paramMap.get('orderId'));

    let jwt = null;
    if (eSignToken) {
      jwt = localStorage.getItem('esign_jwt_' + eSignToken);
      if (jwt) {
        localStorage.removeItem('esign_jwt_' + eSignToken);
      }
    }

    const loanDocTaskId = Number(this._activatedRoute.snapshot.paramMap.get('loanDocTaskId'));

    if (this.taskNumber == this.allTasksCount) {
      this.messageKey = 'portal.esign.allSignedMessage';
      this.messageTitleKey = 'portal.esign.allSignedTitle';
    } else {
      this.messageKey = 'portal.esign.partialSignedMessage';
      this.messageTitleKey = 'portal.esign.partialSignedTitle';
      this.messageParams = { signed: this.taskNumber, total: this.allTasksCount };
    }

    const action = this._activatedRoute.snapshot.queryParamMap.get('event')
      ?? this._activatedRoute.snapshot.queryParamMap.get('esign.status');

    const vendorQueryParameters = this._utilsService.getAllQueryParameters();

    this.portalService
      .onSignerViewSubmittedForAnonymousEsign(eSignToken, loanDocTaskId, action, jwt, vendorQueryParameters)
      .subscribe({
        next: (response) => {
          this._spinner.hide();
          window.parent.postMessage(
            {
              shouldCloseEsignDocIframe: true,
              orderId: this._orderId,
              response: response,
            },
            '*'
          );
        },
        error: (error) => {
          console.error(
            error.error.message
              ? error.error.message
              : 'E-sign confirmation failed.'
          );
          this._spinner.hide();
        },
      });
  }
}
